module.exports = __webpack_public_path__ + "static/media/52.677877f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/52.jpg
// module id = 613
// module chunks = 0